import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-meeting-action',
  templateUrl: './meeting-action.component.html',
  styleUrls: ['./meeting-action.component.scss'],
})
export class MeetingActionComponent implements OnInit {
  @Input() meeting: any = undefined;
  @ViewChild('editor', { static: true }) editor;
  public loaded = false;
  public ckeConfig: any = { extraPlugins: environment.ckConfig };
  public segment = 'observation';
  public buttons = [
    {
      name: 'OBSERVACIONES',
      value: 'observation',
    },
    {
      name: 'HISTORIAL',
      value: 'history',
    },
    {
      name: 'Agendar Nueva Cita',
      value: 'newAppointment',
    },
  ];
  public user = undefined;

  constructor(public modalController: ModalController) {}

  ngOnInit() {
    this.user = this.meeting.user;
  }
}
